module.exports = __webpack_public_path__ + "img/Avatar-99.ed4c6722.svg";